import React from "react";
import { X, Trash2, CheckSquare, Printer, Archive, Reply, ReplyAll, Star, Inbox } from "lucide-react";
import { emailColor } from "../mock";

// Popup funzioni (pressione lunga sulla lista mail)
export default function ContextMenu({ email, onClose, onAction, inArrivoPossibile }) {
  const ripristinabile = !!email && (email.folder === "rifiutate" || email.folder === "eliminate");
  const items = email
    ? [
        ...(ripristinabile ? [{ id: "ripristina", label: "Ripristina in Ricevute", icon: Inbox }] : []),
        { id: "elimina", label: ripristinabile && email.folder === "eliminate" ? "Elimina definitivamente" : "Elimina", icon: Trash2, danger: true },
        ...(inArrivoPossibile ? [{ id: "in_arrivo", label: "Sposta in Posta in arrivo", icon: Inbox }] : []),
        { id: "seleziona", label: "Seleziona", icon: CheckSquare },
        { id: "stampa", label: "Stampa", icon: Printer },
        { id: "archivia", label: "Archivia", icon: Archive },
        { id: "rispondi", label: "Rispondi", icon: Reply },
        { id: "rispondi_tutti", label: "Rispondi a tutti", icon: ReplyAll },
        { id: "preferiti", label: email.preferito ? "Rimuovi dai preferiti" : "Preferiti", icon: Star },
      ]
    : [];

  return (
    <div className={`wf-modal-backdrop ${email ? "show" : ""}`} onClick={onClose}>
      {email && (
        <div className="wf-modal ctx-modal" onClick={(e) => e.stopPropagation()} data-testid="context-menu">
          <div className="wf-modal-head" style={{ marginBottom: 6 }}>
            <span className="wf-modal-title" style={{ minWidth: 0, gap: 10 }}>
              <span
                className="avatar-ring"
                style={{ width: 28, height: 28, minWidth: 28, marginTop: 0, borderColor: emailColor(email) }}
              />
              <span className="attachment-name" style={{ fontSize: 15 }}>{email.mittente}</span>
            </span>
            <button className="icon-btn" onClick={onClose} aria-label="Chiudi" data-testid="ctx-close">
              <X size={20} strokeWidth={2.6} />
            </button>
          </div>
          <div className="ctx-sub">{email.oggetto}</div>

          {items.map((it) => (
            <button
              key={it.id}
              className={`ctx-item ${it.danger ? "danger" : ""}`}
              onClick={() => onAction(it.id)}
              data-testid={`ctx-${it.id}`}
            >
              <it.icon
                size={19}
                strokeWidth={2.3}
                fill={it.id === "preferiti" && email.preferito ? "#f6ba00" : "none"}
                color={it.id === "preferiti" && email.preferito ? "#f6ba00" : "currentColor"}
              />
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
